import React from "react";
import RestrictedWebhookOptionWrapper from "../../RestrictedWebhookOptionWrapper";
import { SelectedWebhookType } from "../../../enums";
import { ArrowLeftRight } from "lucide-react";
import WebhookSelectCard from "./WebhookSelectCard";

interface AsyncPostWebhookProps {
  onSelectedWebhookTypeChange: (selectedWebhookType: SelectedWebhookType) => void;
  selectedWebhookType: Set<SelectedWebhookType>;
  onUnselectingWebhookType: (selectedWebhookType: SelectedWebhookType) => void;
}

function AsyncPostWebhook(props: AsyncPostWebhookProps) {
  const { onSelectedWebhookTypeChange, selectedWebhookType, onUnselectingWebhookType } = props;
  const selected = selectedWebhookType
    ? selectedWebhookType.has(SelectedWebhookType.ASYNC_POST)
    : false;

  return (
    <RestrictedWebhookOptionWrapper>
      <WebhookSelectCard
        title="Async Post completed"
        description="Receive an alert when an async POST has resolved"
        icon={<ArrowLeftRight size={16} />}
        onClick={() => {
          if (selected) {
            onUnselectingWebhookType(SelectedWebhookType.ASYNC_POST);
          } else {
            onSelectedWebhookTypeChange(SelectedWebhookType.ASYNC_POST);
          }
        }}
        selected={selected}
        selectedWebhookType={selectedWebhookType}
      />
    </RestrictedWebhookOptionWrapper>
  );
}

export default AsyncPostWebhook;
